function getLoyaltyDisplayTier(state: App.State) {
  return state.loyalty.account.data?.region
}

export default getLoyaltyDisplayTier
